"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = utfLocaleToJs;
function utfLocaleToJs(utfLocale) {
  return utfLocale ? utfLocale.split('.')[0].replace('_', '-') : '';
}